import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CampaignsDataGrid from '../../../Campaigns/Page/CampaignsDataGrid'
import { MemberStatus } from '../../../../utils/enums';
import useApiManager from '../../../../utils/Api/apiManager';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

const CampaignsDialog = ({ open, setOpen, leadId, fetchCampaigns }) => {
    const [selectedRows, setSelectedRows] = useState(null); // State to store selected row ID
    const [memberStatus, setMemberStatus] = useState(0);
    const { post } = useApiManager();
    const [filters, setFilters] = useState([]);
    const [searchText, setSearchText] = useState('');

    const handleSearchChange = (event) => {
        const inputValue = event.target.value;
        setSearchText(inputValue);

        setFilters([
            {
                fieldName: 'campaignName',
                filterOperator: 2, // "contains" operator
                fieldValue: inputValue || '',
                fieldType: 1, // string type
            },
        ]);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // Handler to capture selected row ID
    const handleSelectionChange = (newSelection) => {
        setSelectedRows(newSelection); // Store selected row IDs
    };

    const handleAddCampaign = async () => {
        if (selectedRows < 1) {
            alert("Please select a row!");
            return;
        }
        try {
            const responseData = await post('/leadcampaigns/add-campaigns-to-lead', {
                leadId: leadId,
                campaignIds: selectedRows,
                memberStatus: memberStatus,
                isContact: false
            });
            console.log('Form Submitted Successfully:', responseData);
            handleClose();
            fetchCampaigns();

            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };
    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Choose Campaign</DialogTitle>
            <DialogContent>
                {/* Search Field */}
                <TextField
                    placeholder="Search Campaign"
                    variant="outlined"
                    size="small"
                    sx={{ mb: 1, mt: 1 }}
                    value={searchText}
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                <Box sx={{ height: 300 }}>
                    <CampaignsDataGrid
                        filters={filters}
                        onSelectionModelChange={handleSelectionChange}
                        contactId={leadId} />
                </Box>

                <Autocomplete
                    disablePortal
                    options={MemberStatus}
                    value={MemberStatus.find((option) => option.value === memberStatus)}
                    size="small"
                    sx={{ width: "20%", mt: 2 }}
                    onChange={(event, newValue) => setMemberStatus(newValue ? newValue.value : '')}
                    renderInput={(params) => <TextField {...params} label="Member Status" />}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                <Button onClick={handleAddCampaign}>Add Campaign</Button>
            </DialogActions>
        </Dialog>
    )
};

export default CampaignsDialog;